<template>
  <HistoryChangeTable
    :endpoint="`v2/vouchers/${voucherId}/change-histories`"
    :action-options="actionOptions"
    :no-change-text="messages.NO_CHANGE_HISTORY"
    :no-match-text="messages.NO_MATCH"
    :invalid-date-range-text="messages.INVALID_DATE_RANGE"
    :on-error="onError"
    :action-label="actionLabel"
    :limit="10"
    @show-detail="showDetail"
  >
    <b-modal
      v-model="detailVisible"
      title="Chi tiết thay đổi"
      size="lg"
      hide-footer
      scrollable
    >
      <dl v-if="detailItem" class="row mb-3">
        <dt class="col-5 col-md-3">Chương trình</dt>
        <dd class="col-7 col-md-9 text-break">
          {{ voucherName }}
          <span
            v-if="isVoucherDeleted"
            class="label label-light-dark label-inline ml-1"
            >Đã xóa</span
          >
        </dd>
        <dt class="col-5 col-md-3">Hành động</dt>
        <dd class="col-7 col-md-9">{{ actionLabel(detailItem) }}</dd>
        <dt class="col-5 col-md-3">Người thực hiện</dt>
        <dd class="col-7 col-md-9">{{ detailItem.updatedByName || '—' }}</dd>
        <dt class="col-5 col-md-3">Thời gian</dt>
        <dd class="col-7 col-md-9">{{ formatTime(detailItem.createdAt) }}</dd>
      </dl>
      <template v-if="infoChanges.length">
        <h6 class="font-weight-bold">Thông tin chung</h6>
        <b-table
          :items="infoChanges"
          :fields="detailFields"
          bordered
          small
          responsive
          class="mb-4"
        >
          <template #cell(before)="{ value }">
            <span class="text-break">{{ value || '' }}</span>
          </template>
          <template #cell(after)="{ value }">
            <span class="text-break">{{ value || '' }}</span>
          </template>
        </b-table>
      </template>

      <template v-if="codeRows.length">
        <h6 class="font-weight-bold">Mã voucher</h6>
        <b-table
          :items="codeRows"
          :fields="codeFields"
          :per-page="CODE_PAGE_SIZE"
          :current-page="codePage"
          bordered
          small
          responsive
          class="mb-2"
        >
          <template #cell(code)="{ value }">
            <span class="text-break">{{ value }}</span>
          </template>
        </b-table>
        <b-pagination
          v-if="codeRows.length > CODE_PAGE_SIZE"
          v-model="codePage"
          :total-rows="codeRows.length"
          :per-page="CODE_PAGE_SIZE"
          size="sm"
          align="right"
        />
      </template>
    </b-modal>
  </HistoryChangeTable>
</template>

<script>
import { formatDate } from '@/utils/common';
import { HISTORY_ACTION_TYPE } from '@/utils/enum';
import {
  HISTORY_TIME_FORMAT,
  VOUCHER_HISTORY_ACTION_OPTIONS,
  VOUCHER_HISTORY_MESSAGES,
} from '@/utils/constants';
import HistoryChangeTable from '@/view/components/history/HistoryChangeTable.vue';
import { toastHistoryError } from '@/view/components/history/history-error';

const DETAIL_FIELD = 'details'; // field của dòng thay đổi mã voucher (API diffDetails)
const CODE_PAGE_SIZE = 50;

export default {
  name: 'VoucherChangeHistory',
  components: { HistoryChangeTable },
  props: {
    voucherId: { type: [Number, String], required: true },
    voucherName: { type: String, default: '' },
    isVoucherDeleted: { type: Boolean, default: false },
  },
  data() {
    return {
      actionOptions: VOUCHER_HISTORY_ACTION_OPTIONS,
      messages: VOUCHER_HISTORY_MESSAGES,
      detailVisible: false,
      detailItem: null,
      detailFields: [
        { key: 'label', label: 'Trường', thStyle: { width: '30%' } },
        { key: 'before', label: 'Trước' },
        { key: 'after', label: 'Sau' },
      ],
      CODE_PAGE_SIZE,
      codePage: 1,
      codeFields: [
        { key: 'change', label: 'Thay đổi', thStyle: { width: '15%' } },
        { key: 'code', label: 'Mã voucher' },
        { key: 'maxUse', label: 'Số lượt tối đa', thStyle: { width: '25%' } },
      ],
    };
  },
  computed: {
    infoChanges() {
      return this.detailItem
        ? this.detailItem.changes.filter((change) => change.field !== DETAIL_FIELD)
        : [];
    },
    codeRows() {
      if (!this.detailItem) return [];
      return this.detailItem.changes
        .filter((change) => change.field === DETAIL_FIELD)
        .map(({ changeType, code, beforeMaxUse, afterMaxUse }) => {
          if (changeType === 'ADD') {
            return { change: 'Thêm', code, maxUse: afterMaxUse };
          }
          if (changeType === 'REMOVE') {
            return { change: 'Xóa', code, maxUse: beforeMaxUse };
          }
          return { change: 'Sửa', code, maxUse: `${beforeMaxUse} → ${afterMaxUse}` };
        });
    },
  },
  methods: {
    // Khóa/Mở dùng mô tả đã lưu
    actionLabel(item) {
      if (!item) return '';
      if (item.action === HISTORY_ACTION_TYPE.TOGGLE_ACTIVE && item.description) {
        return item.description;
      }
      if (item.action === HISTORY_ACTION_TYPE.IMPORT) {
        return item.actionName;
      }
      return `${item.actionName} chương trình`;
    },
    formatTime(value) {
      return formatDate(value, HISTORY_TIME_FORMAT) || '';
    },
    onError(error) {
      toastHistoryError(
        error,
        this.messages.FORBIDDEN,
        this.messages.LOAD_FAILED,
      );
    },
    showDetail(item) {
      this.detailItem = item;
      this.codePage = 1;
      this.detailVisible = true;
    },
  },
};
</script>
